import React, { useState } from "react";
import { Link } from "react-router-dom";
import mad from "./logo.png"; // your logo image

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "HOME", path: "/home" },
    { name: "COURSES", path: "/courses" },
    { name: "DEMOS", path: "/demos" },
    { name: "EVENTS", path: "/events" },
    { name: "ABOUT", path: "/about" },
    { name: "CONTACT", path: "/contact" },
    { name: "BLOG", path: "/blog" },
  ];

  return (
    <>
      <header className="bg-gradient-to-r from-red-600 to-blue-700 shadow-lg sticky top-0 z-50">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 xl:px-20 2xl:px-32">
          <div className="flex justify-between items-center h-16 lg:h-20">
            {/* ---------- LOGO ---------- */}
            <div className="flex items-center">
              <Link to="/">
                <img
                  src={mad}
                  alt="MAD Academy Logo"
                  loading="lazy"
                  className="h-8 w-8 sm:h-10 sm:w-10 mr-2"
                />
              </Link>
            </div>

            {/* ---------- DESKTOP MENU ---------- */}
            <nav className="hidden md:flex items-center space-x-6 lg:space-x-10 xl:space-x-14 2xl:space-x-16">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-white hover:text-blue-300 font-semibold text-sm lg:text-base xl:text-lg transition"
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/start"
                className="bg-gradient-to-r from-red-600 to-blue-600 hover:from-red-700 hover:to-blue-700 text-white font-bold px-4 py-2 lg:px-6 lg:py-3 rounded-lg transition"
              >
                Start for Free
              </Link>
            </nav>

            {/* ---------- MOBILE MENU BUTTON ---------- */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                className="text-white focus:outline-none"
              >
                <svg
                  className="h-7 w-7 sm:h-8 sm:w-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {isOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* ---------- MOBILE DROPDOWN MENU ---------- */}
        <div
          className={`md:hidden bg-gradient-to-b from-red-700 to-blue-800 transition-all duration-300 ease-in-out overflow-hidden ${
            isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="px-4 py-4 space-y-2 text-center">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="block text-white hover:bg-blue-600 rounded-md px-3 py-2 text-sm font-medium transition"
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/start"
              onClick={() => setIsOpen(false)}
              className="block bg-gradient-to-r from-red-600 to-blue-600 hover:from-red-700 hover:to-blue-700 text-white font-bold px-4 py-2 rounded-lg transition mt-3"
            >
              Start for Free
            </Link>
          </div>
        </div>
      </header>
    </>
  );
};

export default Menu;
